'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { fireFloodlightPixel, FLOODLIGHT_ACTIVITIES } from '@/lib/floodlight';

// Site-wide Floodlight pixel — fires on first load and on every client-side
// route change, since the root layout does not remount between pages.
export default function FloodlightAllSitePixel() {
  const pathname = usePathname();

  useEffect(() => {
    fireFloodlightPixel(FLOODLIGHT_ACTIVITIES.allSite);
  }, [pathname]);

  return null;
}
